var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgArrowRight = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 31 31"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16-27.5A15.5,15.5,0,0,0,.5-12,15.5,15.5,0,0,0,16,3.5,15.5,15.5,0,0,0,31.5-12,15.5,15.5,0,0,0,16-27.5ZM8.75-9.25A.752.752,0,0,1,8-10v-4a.752.752,0,0,1,.75-.75H16v-4.431a.75.75,0,0,1,1.281-.531l7.144,7.187a.743.743,0,0,1,0,1.056L17.281-4.287A.751.751,0,0,1,16-4.819V-9.25Z",
  transform: "translate(-0.499 27.5)"
})));
export default SvgArrowRight;